import { Component, AfterContentInit, Input, ContentChildren, QueryList, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { encapsulation } from '../../components/encapsulation';
import { UBXColor, UBXTabsDirection } from '../../models';
import { UBXTabsTabComponent } from './tab/tabs-tab.component';

@Component({
    selector: 'ubx-tabs',
    templateUrl: './tabs.component.html',
    host: { class: 'ubx-tabs flx f-fd:c' },
    encapsulation
})
export class UBXTabsComponent implements AfterContentInit {
    @Input() theme: UBXColor = UBXColor.Inf;
    @Input() isActive = 0;

    @ContentChildren(UBXTabsTabComponent) tabs: QueryList<UBXTabsTabComponent>;
    @ViewChild('tab', { static: true }) tab: ElementRef;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
    ) { }

    ngAfterContentInit() {
        this.setActiveTab(this.isActive);
    }

    setActiveTab(active: number) {
        this.tabs.forEach((tab: UBXTabsTabComponent, i: number) => {
            if (active === i) {
                this.isActive = i;
            }
            tab.active = active === i ? true : false;
            active === i ? this.appendChild(tab.el) : this.removeChild(tab.el);
        });
    }

    labelClass(active: boolean): string {
        return active ? `bg:${this.theme} clr:wht` : '';
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
    private appendChild(el: ElementRef) {
        this.renderer.appendChild(this.tab.nativeElement, el.nativeElement);
    }
    private removeChild(el: ElementRef) {
        this.renderer.removeChild(this.tab.nativeElement, el.nativeElement);
    }
}
